export enum LoaderType {
  BLOCKING = 'BLOCKING',
  GHOST = 'GHOST',
  BUTTON = 'BUTTON',
}

export enum PasswordLengthIndicator {
  WEAK = 'WEAK',
  MEDIUM = 'MEDIUM',
  STRONG = 'STRONG',
}

export interface AccountFieldLabel {
  text: string
  error?: boolean
}
